import React from 'react';
import { Navigate } from 'react-router-dom';
import { TruckerListing } from 'trucker-listing';

const redirect = (to: string, replace = true) => <Navigate to={to} replace={replace} />;

const Profile = (): JSX.Element => null;

export const localRoutes = [
  {
    path: '',
    element: <TruckerListing />,
    children: [
      {
        path: ':truckerId?',
        element: <Profile />,
      },
    ],
  },
  {
    path: 'sugeridos',
    element: redirect('/meus-fretes/abc/motoristas/sugeridos'),
  },
  {
    path: 'tarifa',
    element: redirect('/meus-fretes/abc/motoristas/tarifa'),
  },
  {
    path: 'meus-fretes/:freightId?/motoristas/:activeTab?',
    element: <TruckerListing />,
    children: [
      {
        path: ':truckerId?',
        element: <Profile />,
      },
    ],
  },
];
